import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import AuthRedirect from "./components/AuthRedirect";
import "./index.css";
import App from "./App";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.handleRedirectPromise().then((response) => {
  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
  }
}).catch((error) => {
  console.error("MSAL redirect error:", error);
});

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <Routes>
          <Route path="/auth/redirect" element={<AuthRedirect />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
